require('bootstrap-select');

const init = () => $('.selectpicker').selectpicker('render');

// Quickly initialize bootstrap-select objects
try {
    init();
} catch (log) {
    // Log init failures
    window.console?.log?.(log);

    try {
        // Allow main thread to complete and retry
        setTimeout(init, 0);
    } catch (error) {
        window.console?.error?.(error);
    }
}

module.exports = {
    methods: {
        init: init
    },
    updateValidity: function () {
        $('.selectpicker').on('changed.bs.select', function () {
            if (this.checkValidity()) {
                $(this).removeClass('is-invalid');
            }
        });
    }
};

